<template>
  <div class="w-full h-fit flex flex-col items-center justify-center p-lg border-border border-3 border-solid rounded-2xl">
    <div class="empty-state-icon text-black rounded-full h-xxl w-xxl p-base flex items-center justify-center border-black border-3 border-solid mb-base">
      <slot name="icon" />
    </div>
    <div class="text-black text-20">
      <slot name="title" />
    </div>
    <div class="empty-state-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseEmptyState',
};
</script>

<style scoped>
.empty-state-icon svg {
  @apply h-twentyFive w-twentyFive;
}
.empty-state-content p {
  @apply text-13 text-dark3;
}
.empty-state-content a {
  @apply text-primaryGradient;
}
</style>
